import { FadeUp, MaskLines, Em } from "@/components/site/Motion";
import { FlagRow } from "@/components/site/Flags";
import { Brand } from "@/components/site/Logo";
import { WINGS } from "@/lib/site";

const Badge = () => (
  <div className="spin-slow pointer-events-none h-36 w-36 sm:h-44 sm:w-44" aria-hidden="true">
    <svg viewBox="0 0 200 200" className="h-full w-full">
      <defs><path id="circ" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" /></defs>
      <circle cx="100" cy="100" r="98" fill="#D4FF3D" />
      <text className="font-mono-x" fontSize="14.5" letterSpacing="4" fill="#0E0E10">
        <textPath href="#circ">ONE JERSEY · TWO WINGS · ONE JERSEY · TWO WINGS ·</textPath>
      </text>
      <path d="M78 120 L100 70 L122 120" fill="none" stroke="#0E0E10" strokeWidth="6" strokeLinejoin="round" />
    </svg>
  </div>
);

const Wing = ({ wing, flags, title, body, dark, testid, className }) => (
  <FadeUp className={`relative flex flex-col justify-between gap-12 p-8 sm:p-12 ${dark ? "bg-[#0E0E10] text-[#F1ECE2]" : "border-2 border-[#0E0E10] bg-[#F1ECE2]"} ${className}`} data-testid={testid}>
    <div className="flex items-center justify-between">
      <FlagRow ids={flags} size="w-6" />
      <a href={`https://${wing.domain}`} target="_blank" rel="noreferrer" className="font-mono-x ul-draw text-xs" data-testid={`${testid}-domain`}>{wing.domain}</a>
    </div>
    <div>
      <p className="font-display text-6xl font-bold tracking-[-0.04em] sm:text-7xl">{wing.name}</p>
      <p className="font-serif-i mt-2 text-2xl">{title}</p>
      <p className={`mt-6 max-w-md leading-relaxed ${dark ? "text-[#d6d0c4]" : "text-[#3d3a35]"}`}>{body}</p>
    </div>
  </FadeUp>
);

export const Wings = () => (
  <section className="relative bg-[#E7E0D2] px-5 py-24 sm:px-8 lg:py-36" data-testid="wings-section">
    <div className="mx-auto max-w-[1400px]">
      <div className="flex items-center gap-4">
        <img src="/logo-shield.png" alt="" aria-hidden="true" className="h-10 w-auto" />
        <Brand size="lg" testid="wings-brand" />
      </div>
      <MaskLines as="h2" lines={["two companies grew up", <>apart. <Em>same stubborn streak.</Em></>]}
        className="font-display mt-6 max-w-5xl text-4xl font-bold leading-[0.95] tracking-[-0.03em] sm:text-6xl" />
      <div className="mt-16 grid gap-5 lg:grid-cols-[5fr_auto_7fr] lg:items-stretch">
        <Wing wing={WINGS.pitsus} flags={["us"]} title="the American wing." dark testid="wing-pitsus" className="lg:mt-16"
          body="Close to the hiring managers, the time zones and the way US teams actually interview. Contract, C2H and full-time, coast to coast." />
        <div className="flex items-center justify-center py-4 lg:px-2 lg:py-0" data-testid="wings-badge"><Badge /></div>
        <Wing wing={WINGS.pitsind} flags={["uk", "eu", "apac"]} title="the global wing, from Chennai." testid="wing-pitsind"
          body="A deep bench of engineers and a delivery desk that's awake while the West sleeps. Serving teams in the UK, across EMEA and through APAC." />
      </div>
    </div>
  </section>
);
